import React from 'react'

export const DeliveryMethodIcon = () => (
  <svg width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.21.283a2.459 2.459 0 0 0-2.292 0L1.146 3.36C.436 3.738 0 4.436 0 5.192v6.154c0 .755.436 1.454 1.146 1.832l5.772 3.077a2.46 2.46 0 0 0 2.291 0l5.772-3.077c.71-.378 1.146-1.077 1.146-1.833V5.192c0-.755-.436-1.454-1.146-1.832L9.21.283zm-.625 1a1.119 1.119 0 0 0-1.042 0h1.042zm-1.042 0L1.77 4.36a.95.95 0 0 0-.521.832v6.154a.95.95 0 0 0 .52.833l5.772 3.076c.323.172.72.172 1.043 0l5.771-3.077a.95.95 0 0 0 .521-.833V5.192a.95.95 0 0 0-.52-.832L8.584 1.283"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.463 8.464c-.173-.275-.556-.37-.854-.21l-2.5 1.34c-.3.16-.4.513-.228.788.174.276.556.37.855.21l2.5-1.339c.298-.16.4-.513.227-.789zM15.82 4.135c-.172-.276-.555-.371-.854-.212l-6.902 3.68-6.903-3.68C.862 3.764.48 3.86.307 4.135c-.172.275-.07.628.23.788L7.75 8.769a.67.67 0 0 0 .625 0l7.215-3.846c.3-.16.402-.513.23-.788z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.064 7.692c-.346 0-.625.258-.625.577v7.694c0 .319.28.577.625.577s.625-.258.625-.577V8.269c0-.319-.28-.577-.625-.577zM3.689 2.095c-.173.276-.07.63.229.788l7.442 3.963c.299.159.681.064.854-.212.172-.276.07-.629-.23-.788L4.542 1.884c-.299-.16-.68-.065-.853.211z"
      fill="#000"
    />
  </svg>
)
